module.exports = __webpack_public_path__ + "static/media/Twitter.47f21b48.svg";